import { Component, Input, Output, EventEmitter, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ButtonForm } from "../../button-form/button-form";
import { OngetSideBar } from "../../onget-side-bar/onget-side-bar";
import { Modal } from '../../modal/modal';
import { AuthService } from '../../../core/services/auth/auth-service';

@Component({
  selector: 'app-sidebar-super-admin',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonForm, OngetSideBar, Modal],
  templateUrl: './sidebar-super-admin.html',
  styleUrl: './sidebar-super-admin.css',
})
export class SidebarSuperAdmin {
  showModal = signal<boolean>(false);

  @Input() isOpen = false;
  @Output() toggleSidebar = new EventEmitter<void>();
  private authService = inject(AuthService);
  private breakpointObserver = inject(BreakpointObserver);

  mainMenu = [
    { label: 'Tableau de bord', icon: 'home', route: '/super-admin/dashboard' },
    { label: 'Clubs & Salles', icon: 'building', route: '/super-admin/member-ships' },
    { label: 'Admissions Coachs', icon: 'award', route: '/super-admin/coach-admissions' },
  ];

  toggleModal() {
    this.showModal.set(!this.showModal());
  }

  onItemClick() {
    if (this.breakpointObserver.isMatched([Breakpoints.Handset, '(max-width: 1023.98px)'])) {
      this.toggleSidebar.emit();
    }
  }

  onLogout() {
    this.authService.logout();
  }
}
